import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </Tag>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease: EASE, delay: 0.08 + i * 0.11 } }),
};

// Masked line-by-line reveal. Observer sits on the unclipped wrapper; each line is clipped individually.
export const MaskedLines = ({ lines, as = "h2", className = "", onMount = false }) => {
  const Tag = motion[as];
  const trigger = onMount
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <Tag className={className} {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className={`block ${line.className || ""}`} custom={i} variants={lineVariants}>
            {line.content}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
